import request from '@/utils/request'

// BD工单列表分页
export function bdOrderList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/bd-work-order/page-list',
    method: 'post',
    data
  })
}
//查询复诊提醒工单子待办信息
export function getBDSubTaskDetail(data) {
  return request({
    url: '/health-doctor-assistant/subTask/query/byWorkOrderId',
    method: 'get',
    params: data
  })
}
// 上传凭证
export function uploadQualityProof(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/uploadQualityProof',
    method: 'post',
    data
  })
}
// 查询+校验痕迹接口（实时）
export const queryQualityTraceDetection = data => {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/queryQualityTraceDetection',
    method: 'get',
    params: data
  })
}
// 查询痕迹接口
export const querySolidifyQualityTraceDetection = data => {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/querySolidifyQualityTraceDetection',
    method: 'get',
    params: data
  })
}
//查询工单质检凭证
export const queryQualityInspectionProof = data => {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/queryQualityInspectionProof',
    method: 'get',
    params: data
  })
}
// 工单质检凭证审核
export function approveQualityInspectionProof(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/approveQualityInspectionProof',
    method: 'post',
    params: data
  })
}
